import { render, staticRenderFns } from "./user_item.vue?vue&type=template&id=4f565e06"
import script from "./user_item.vue?vue&type=script&lang=js"
export * from "./user_item.vue?vue&type=script&lang=js"
import style0 from "./user_item.vue?vue&type=style&index=0&id=4f565e06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports